/* src/app/modules/print-cards/components/cards/backgrounds/address-cards-1x3/fika-concentrate-address-card-stack-background/fika-concentrate-address-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .bottom-half-of-card {
  position: absolute;
  bottom: 0;
  width: 100%;
}
/*# sourceMappingURL=fika-concentrate-address-card-stack-background.component.css.map */
